import { Grid } from "@mui/material"
import { useGetOne, useRefresh } from "ra-core"
import { FC } from "react"
import AlertsCard from "@/components/backups/BackupAlertsCard"
import { BackupStatusCard, ValidationStatusCard } from "@/components/backups/BackupStatusCard"
import { Content } from "@/components/content/Content"
import { RecPatch } from "@/dataProvider/tools"
import { BackupDashboardResponseDto } from "@/gen/api/backup"
import { OdResourcePageProps } from "@/types/resource"


const BackupValidationDashboard: FC<OdResourcePageProps> = ({
  options,
  resource = 'backups-n-validations/dashboard',
}) => {
  const { data } = useGetOne<BackupDashboardResponseDto & RecPatch>(resource, -1)
  const refresh = useRefresh()

  return (
    <Content pageName="Data Continuity Dashboard" resourceName="backupValidationDashboard" breadcrumbs={options?.breadcrumbs}>
      <Grid 
        container 
        direction="row" 
        wrap="wrap" 
        spacing={4} 
        sx={{ mt: 2 }}
      >
        <Grid item xs={12} sm={6}>
          <BackupStatusCard 
            successCount={data?.backupSuccessCount} 
            warningCount={data?.backupWarningCount} 
            errorCount={data?.backupFailedCount}
            onRefresh={refresh} 
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AlertsCard title="Backup Alerts" alertInfo={data?.backupAlerts} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ValidationStatusCard 
            successCount={data?.validationSuccessCount} 
            warningCount={data?.validationWarningCount} 
            errorCount={data?.validationFailedCount}
            onRefresh={refresh} 
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <AlertsCard title="Validation Alerts" alertInfo={data?.validationAlerts} />
        </Grid>
      </Grid>
    </Content>
  )
}

export default BackupValidationDashboard;
